import { gql } from 'graphql-request';

export const FETCH_CACHE_TASK_MEMBER_INVITES_TOTAL_COUNT_QUERY = gql`
  query CacheTaskMemberInvitesTotalCount(
    $filters: TaskMemberInvitesFilters
    $sort: [TaskMemberInvitesSortEnum!]
    $limit: Int
    $offset: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    taskMemberInvites(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      paginationInfo {
        nextPage
        totalCount
      }
    }
  }
`;
